import { Input } from "@/components/ui/baseUi/input"
import { cn } from "@/modules/lib/utils"
import { EyeIcon, EyeOffIcon } from "lucide-react"
import { useState } from "react"

type PasswordInputProps = {
  inputProps?: React.ComponentProps<"input">
} & React.ComponentProps<"div">

export function PasswordInput({ className, inputProps, ...props }: PasswordInputProps) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  return (
    <div className={cn("relative", className)} {...props}>
      <Input
        name="password"
        type={isPasswordVisible ? "text" : "password"}
        placeholder={inputProps?.placeholder || "••••••••"}
        {...inputProps}
      />
      {isPasswordVisible ? (
        <EyeOffIcon
          onClick={() => setIsPasswordVisible(!isPasswordVisible)}
          className="absolute top-1/2 right-3 size-4 -translate-y-1/2 cursor-pointer text-textDefault-placeholder"
        />
      ) : (
        <EyeIcon
          onClick={() => setIsPasswordVisible(!isPasswordVisible)}
          className="absolute top-1/2 right-3 size-4 -translate-y-1/2 cursor-pointer text-textDefault-placeholder"
        />
      )}
    </div>
  )
}
